import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { docsStructure } from '../docsStructure'
import { ChevronRight, Menu } from 'lucide-react'

function NavLinks({ currentSlug, onNavigate }: { currentSlug: string; onNavigate?: () => void }) {
  return (
    <div className="space-y-6">
      {docsStructure.map((section) => (
        <div key={section.title}>
          <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-3">
            {section.title}
          </h3>
          <ul className="space-y-1">
            {section.pages.map((page) => {
              const isActive = currentSlug === page.slug
              return (
                <li key={page.slug}>
                  <Link
                    to={`/docs/${page.slug}`}
                    onClick={onNavigate}
                    className={cn(
                      'flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors',
                      isActive
                        ? 'bg-primary text-primary-foreground font-medium'
                        : 'text-muted-foreground hover:text-foreground hover:bg-accent'
                    )}
                  >
                    {isActive && <ChevronRight className="h-4 w-4" />}
                    <span className={cn(!isActive && 'ml-6')}>{page.title}</span>
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      ))}
    </div>
  )
}

export function DocsSidebar() {
  const location = useLocation()
  const [mobileOpen, setMobileOpen] = useState(false)
  const currentSlug = location.pathname.replace(/^\/docs\/?/, '')
  return (
    <>
      {/* Mobile: collapsible nav */}
      <div className="md:hidden mb-4">
        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className="flex w-full items-center gap-2 rounded-lg border border-border bg-background px-4 py-3 text-sm font-medium"
        >
          <Menu className="h-4 w-4 text-muted-foreground" />
          <span>Docs</span>
          <ChevronRight className={cn('ml-auto h-4 w-4 text-muted-foreground transition-transform', mobileOpen && 'rotate-90')} />
        </button>
        {mobileOpen && (
          <div className="mt-2 rounded-lg border border-border bg-background p-4">
            <NavLinks currentSlug={currentSlug} onNavigate={() => setMobileOpen(false)} />
          </div>
        )}
      </div>

      {/* Desktop: fixed sidebar */}
      <nav className="hidden md:block w-64 flex-shrink-0 border-r bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 overflow-y-auto">
        <div className="p-6">
          <NavLinks currentSlug={currentSlug} />
        </div>
      </nav>
    </>
  )
}
